const ContactEmailDeliverability = ({
  contactEmail = '',
  isDeliverable = true,
  isPurgeLimitExceeded = false,
  supportEmail = '',
  dateEmailVerified = '',
} = {}) => ({
  contactEmail: String(contactEmail),
  isDeliverable: Boolean(isDeliverable),
  isPurgeLimitExceeded: Boolean(isPurgeLimitExceeded),
  supportEmail: String(supportEmail),
  dateEmailVerified: String(dateEmailVerified),
});

export default ContactEmailDeliverability;

export type ContactEmailDeliverabilityProps = ReturnType<typeof ContactEmailDeliverability>;
